export default __webpack_public_path__ + "locales/ru/ChangeUserTypeDialog.json?hash=2c01365645fe4cc803feb2d7682dca7f";